export default async (response: Response) => {
  // check for error response
  if (!response.ok) {
    let data;

    try {
      data = await response.json();
    } catch {
      // ignore error
    }

    // get error message from body or default to response status
    const error =
      data && typeof data === 'object'
        ? { status: response.status, statusText: response.statusText, ...data }
        : new Error(
            `Failed to fetch "${response.url}" with status ${
              response.status
            } "${response.statusText}": ${String(data)}`,
          );

    // throw error so it can be caught
    throw error;
  }

  return response;
};
